import accounting from 'accounting';

const formatCurrency = (amount) => accounting.formatMoney(amount);

export default formatCurrency;
